import '../../../../src/ts/components/zv/gallery/component';